import Event from '../../core/Event';
import Estimations from '../../../domain/estimations/Estimations';

export default class EstimationsDraftSaveSucceed extends Event {
    public static type = 'EstimationsDraftSaveSucceed';

    constructor(public readonly estimations: Estimations) {
        super(EstimationsDraftSaveSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsDraftSaveSucceed.ts